/**
 * Enumération des statistiques AT Internet de l'application.
 */
export enum MappingEventStatistiques {
	// Page principale
	pageAccueil = 'Formulaire_avvc::page avvc',
	// Clic sur le bouton "Accéder à la demande d'aide"
	clicDemandeAide = 'Formulaire_avvc::acceder demande',
	// Clic sur le lien vers comment effacer ses traces sur internet
	clicEffacerTraces = 'Formulaire_avvc::supprimer traces',
	// Préfixe du clic sur l'un des choix du champ sur le nombre d'enfants
	clicChampCombienEnfants = 'Formulaire_avvc::faq nb enfant',
	// Préfixe du clic sur l'un des choix du champ sur le montant du salaire
	clicChampCombienSalaire = 'Formulaire_avvc::faq',
	// Clic sur la réponse oui du champ "résidez-vous en France"
	clicChampResidenceOui = 'Formulaire_avvc::demande residence oui',
	// Clic sur la réponse oui du champ "résidez-vous en France"
	clicChampResidenceNon = 'Formulaire_avvc::demande residence non',
	// Clic sur la réponse oui du champ "êtes-vous de nationalité française"
	clicChampStatutOui = 'Formulaire_avvc::demande nationalite oui',
	// Clic sur la réponse oui du champ "êtes-vous de nationalité française"
	clicChampStatutNon = 'Formulaire_avvc::demande nationalite non',
	// Clic sur la réponse oui du champ "pièce justificative"
	clicChampJustificatifOui = 'Formulaire_avvc::demande justificatif oui',
	// Clic sur la réponse oui du champ "pièce justificative"
	clicChampJustificatifNon = 'Formulaire_avvc::demande justificatif non',
	// Clic sur la réponse "CAF" du champ "organisme"
	clicChampOrganismeCaf = 'Formulaire_avvc::demande organisme caf',
	// Clic sur la réponse "MSA" du champ "organisme"
	clicChampOrganismeMsa = 'Formulaire_avvc::demande organisme msa',
	// Clic sur la réponse "Autre" du champ "organisme"
	clicChampOrganismeAutre = 'Formulaire_avvc::demande organisme autre',
	// Clic sur le bouton "faire la demande"
	clicBoutonFaireDemande = 'Formulaire_avvc::demande site',
	// Clic sur le lien "consulter les démarches du service public"
	clicLienTrouverAide = 'Formulaire_avvc::trouvez aide'
}
